<template>
    <div>
        <span class="widget-info" @click.stop="showDescription($event)">
            <i class="fa-light fa-info-circle"></i>
        </span>

        <div ref="tooltip" class="widget-tooltip" hidden @click.stop="hideDescription($event)">
            <button type="button" class="close" @click.stop="hideDescription($event)">
                <i class="fa-light fa-times"></i>
            </button>

            <div class="content">
                {{ content }}
            </div>
        </div>
    </div>
</template>

<script>

    import Widget from './Widget.vue';

    export default {
        extends: Widget,
        props: {
            content: String
        },

        methods: {
            showDescription(event) {
                this.$refs.tooltip.removeAttribute('hidden');
            },
            hideDescription(event) {
                this.$refs.tooltip.setAttribute('hidden', 'hidden');
            }
        }
    }
</script>
